// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y4AW","col":"styles_col__38dHz","actions":"styles_actions__3p-RR","conflict":"styles_conflict__3zbGv"};